"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldPublicsPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_1 = require("react-router");
var react_query_1 = require("react-query");
var util_1 = require("../util");
var api_1 = require("../api");
var World_1 = require("./World");
var PagenationMenu_1 = require("./PagenationMenu");
var PagenationBySize_1 = require("./PagenationBySize");
var SearchWorldsForm_1 = require("./SearchWorldsForm");
var i18n_1 = __importDefault(require("../i18n"));
exports.WorldPublicsPage = (0, react_router_1.withRouter)(function WorldPublics(props) {
    var page = props.page, setPage = props.setPage, worldsPageSize = props.worldsPageSize, setWorldsPageSize = props.setWorldsPageSize, addWorlds = props.addWorlds, worlds = props.worlds, worldSearchParams = props.worldSearchParams;
    var publicWorldIds = (0, react_1.useMemo)(function () { return Object.keys(worlds).filter(function (id) { return worlds[id].releaseStatus === "public"; }); }, [
        worlds,
    ]);
    var _a = (0, react_query_1.useInfiniteQuery)("publicWorlds", function (_a) {
        var _b = _a.pageParam, pageParam = _b === void 0 ? 1 : _b;
        return (0, api_1.fetchPublicWorldsByPage)(pageParam);
    }), worldsInfiniteArray = _a.data, isLoading = _a.isLoading, fetchNextPage = _a.fetchNextPage;
    (0, react_1.useEffect)(function () {
        if (!worldsInfiniteArray)
            return;
        var lastPage = worldsInfiniteArray.pages[worldsInfiniteArray.pages.length - 1];
        if (lastPage.length) {
            fetchNextPage({ pageParam: worldsInfiniteArray.pages.length + 1 });
        }
    }, [worldsInfiniteArray]);
    /*
    const worldIds = useMemo(() => worldsArray?.map(w => w.id), [worldsArray]);
    const { data: worldProfiles } = useQuery(
        ["publicWorldProfiles", worldIds],
        () =>
            Promise.all(eachSlice(worldIds!, 100).map(ids => fetchWorldProfiles(ids))).then(results =>
                results.reduce((a, p) => a.concat(p))
            ),
        {
            enabled: !!worldIds?.length,
        }
    );
    */
    var worldProfiles = (0, react_1.useMemo)(function () { return []; }, []);
    (0, react_1.useEffect)(function () {
        if (worldsInfiniteArray && [worldProfiles]) {
            var _worlds = (0, util_1.joinWorldAndProfiles)(worldsInfiniteArray.pages[worldsInfiniteArray.pages.length - 1], worldProfiles);
            addWorlds(_worlds);
        }
    }, [worldsInfiniteArray, worldProfiles]);
    var pageProps = (0, util_1.routePageProps)(props, {
        page: page("worldsPublic"),
        setPage: function (_page) { return setPage("worldsPublic", _page); },
        pageSize: worldsPageSize,
        setPageSize: setWorldsPageSize,
    });
    var searchWorlds = (0, util_1.genSearchWorlds)({ worldSearchParams: worldSearchParams, worlds: worlds });
    var sWorldIds = searchWorlds(publicWorldIds);
    var useWorldIds = (0, PagenationBySize_1.pagenate)(sWorldIds, pageProps.page, pageProps.pageSize);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SearchWorldsForm_1.SearchWorldsForm, {}), (0, jsx_runtime_1.jsx)(PagenationMenu_1.PagenationMenu, __assign({}, pageProps, { length: sWorldIds.length })), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { doubling: true, stackable: true, columns: 4, children: [useWorldIds.length ? (useWorldIds
                        .map(function (id) { return worlds[id]; })
                        .map(function (world) { return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsx)(World_1.World, { world: world }) }, world.id)); })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), isLoading && i18n_1.default.loading] })] }));
});
